import { useTranslation } from 'react-i18next';
import { formatAddressText } from '~/utils/addressFormat';
import { ContactCard } from '~/components/cards/ContactCard';
import type { GetQuoteByIdQuery } from '~/graphql/graphql';

type BuyerRequestDetailsProps = {
  requestForQuote: NonNullable<GetQuoteByIdQuery['quote']>['requestForQuote'];
};

export function BuyerRequestDetails({
  requestForQuote,
}: Readonly<BuyerRequestDetailsProps>) {
  const { t } = useTranslation('rfq-view');
  const shippingLocation = requestForQuote.shippingLocation;
  const address = shippingLocation?.facility.address;

  return (
    <div className="flex flex-col sm:flex-row gap-4 items-start">
      <div className="flex-1 min-w-0">
        <p className="text-sm text-neut-prim mb-1">
          <span className="font-semibold">{t('rfq_view.buyer_label')}:</span>{' '}
          {requestForQuote.buyingOrganization.name}
          {!requestForQuote.createdByUser &&
            requestForQuote.createdByUserName &&
            ` —${requestForQuote.createdByUserName}`}
        </p>

        {shippingLocation && (
          <p className="text-sm text-neut-prim mb-1">
            <span className="font-semibold">
              {t('rfq_view.ship_to_location_label')}:
            </span>{' '}
            {shippingLocation.code} — {shippingLocation.name}
            {address && `, ${formatAddressText(address)}`}
          </p>
        )}

        {requestForQuote.transportVehicle && (
          <p className="text-sm text-neut-prim mb-1">
            <span className="font-semibold">
              {t('rfq_view.transport_vehicle_label')}:
            </span>{' '}
            {requestForQuote.transportVehicle.name}
          </p>
        )}

        {requestForQuote.leadTimeDays != null && (
          <p className="text-sm text-neut-prim mb-1">
            <span className="font-semibold">
              {t('rfq_view.lead_time_label')}:
            </span>{' '}
            {t('rfq_view.lead_time_days', {
              count: requestForQuote.leadTimeDays,
            })}
          </p>
        )}
      </div>
      {requestForQuote.createdByUser && (
        <div className="w-full sm:w-80">
          <ContactCard contact={requestForQuote.createdByUser} />
        </div>
      )}
    </div>
  );
}
